import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  return <div className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-238" data-mp="3f2wxhmr351x8">
      {eyebrow && <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand" data-id="element-239" data-mp="3k0oyr7dme0e3">{eyebrow}</p>}
      <h2 className="mt-2 font-display text-[26px] uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-240" data-mp="bl5bcozmrc6y">
        {title}
      </h2>
      {subtitle && <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-241" data-mp="1v3m3tvjjnqg">
          {subtitle}
        </p>}
    </div>;
}